export const FriendsTab = {
  Friends: "friends",
  Groups: "groups",
} as const;
export type FriendsTab = (typeof FriendsTab)[keyof typeof FriendsTab];

export const FRIENDS_TABS: { id: FriendsTab; label: string }[] = [
  { id: FriendsTab.Friends, label: "Friends" },
  { id: FriendsTab.Groups, label: "Groups" },
];

/** Avatar edits are staged in the Friend modal and only sent on Save. */
export type AvatarDraft =
  | { kind: "unchanged" }
  | { kind: "emoji"; emoji: string }
  | { kind: "photo"; blob: Blob; previewUrl: string }
  | { kind: "none" };

export const INPUT_CLASS =
  "rounded-lg border border-border bg-transparent px-3 py-1.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40";
